<template>
  <q-dialog
    v-model="show"
    :maximized="maximized"
    @input="(val) => $emit('input', val)"
  >
    <q-layout view="Lhh lpR fff" container class="tw-bg-white modal-medium">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>#Search#</q-toolbar-title>
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
      </q-header>
      <q-page-container style="max-height: 85vh" class="scroll">
            PESQUISAR UNIDADES
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../ServiceRequestController'
import ServiceRequestModel from '../ServiceRequestModel'
import { JtCrud } from 'jtech-webcomps'
const { modal } = JtCrud

@Component({
  name: 'ServiceRequestModalSearchConsumerUnit',
  components: { 'crud-modal': modal },
  props: {
    protocol: String,
    show: {
      type: Boolean,
      default: false
    }
  }
})
class ServiceRequestModalSearchConsumerUnit extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  message = '';
  onFinish () {
    // this.controller.finishEnd({ message: this.message, protocol: this.protocol })
  }
}
export default ServiceRequestModalSearchConsumerUnit
</script>
<style lang="stylus" scoped></style>
